import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <main className="privacy-policy-page">
      <div className="privacy-policy-container">
        <h1>Política de Privacidad - Alora</h1>
        <p className="privacy-policy-updated">Última actualización: Marzo 2026</p>

        <p>
          En Alora ("nosotros", "nuestro" o "la aplicación"), respetamos tu
          privacidad. Esta política explica qué información usamos y cómo la tratamos.
        </p>
        <p>
          Alora no almacena contenido personal de los usuarios como videos, audios,
          respuestas o recuerdos.
        </p>

        <h2>1. Información que recopilamos</h2>
        <p>
          Recopilamos únicamente datos de navegación y uso con fines estadísticos,
          por ejemplo:
        </p>
        <ul>
          <li>Pantallas visitadas y flujo de navegación</li>
          <li>Eventos de uso dentro de la aplicación</li>
          <li>Información técnica básica (tipo de dispositivo, sistema y versión de la app)</li>
        </ul>
        <p>
          No recopilamos ni almacenamos videos, audios, respuestas personales ni otro
          contenido generado por el usuario.
        </p>

        <h2>2. Cómo utilizamos tu información</h2>
        <p>Usamos los datos de navegación para:</p>
        <ul>
          <li>Analizar el uso general de la aplicación</li>
          <li>Mejorar la experiencia y el rendimiento</li>
          <li>Tomar decisiones de producto basadas en estadísticas de uso</li>
        </ul>
        <p>Alora no vende tu información personal.</p>

        <h2>3. Almacenamiento de datos</h2>
        <p>Alora no almacena contenido personal como videos, audios o respuestas.</p>
        <p>
          Los datos de navegación utilizados para estadísticas pueden procesarse de forma
          agregada o anonimizada.
        </p>

        <h2>4. Compartición de información</h2>
        <p>No vendemos ni alquilamos información de los usuarios.</p>
        <p>
          En caso de usar servicios de analítica, solo se comparte información técnica o
          estadística necesaria para medir uso y desempeño.
        </p>

        <h2>5. Control de tus datos</h2>
        <p>
          Como no almacenamos contenido personal dentro de Alora, no conservamos videos,
          respuestas ni recuerdos en nuestros sistemas.
        </p>
        <p>
          Si tienes dudas sobre el tratamiento de datos de navegación, puedes escribirnos
          al correo de contacto.
        </p>

        <h2>6. Privacidad de menores</h2>
        <p>Alora no está dirigida a menores de 13 años.</p>
        <p>
          No recopilamos intencionalmente información personal de menores de 13 años.
        </p>

        <h2>7. Seguridad de la información</h2>
        <p>
          Aplicamos medidas técnicas y organizativas razonables para proteger la información
          técnica y estadística que se procese.
        </p>

        <h2>8. Cambios en esta política</h2>
        <p>
          Podemos actualizar esta Política de Privacidad ocasionalmente. Cualquier cambio se
          reflejará en la fecha de "Última actualización".
        </p>

        <h2>9. Contacto</h2>
        <p>
          Si tienes preguntas sobre esta Política de Privacidad, puedes contactarnos en:
        </p>
        <p>
          Email:{' '}
          <a href="mailto:support_alora@mindware.com.mx" className="privacy-policy-email">
            support_alora@mindware.com.mx
          </a>
        </p>
      </div>
    </main>
  );
};
